import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import '../styles/pages/Legal.scss';

const Privacy = () => {
    return (
        <div className="legal-page">
            <Navbar />
            <main className="legal-content">
                <h1>Privacy Policy</h1>
                <p className="legal-updated">Last updated: August 2026</p>

                <p>
                    YeniDers ("we", "us", "our") respects your privacy. This policy explains
                    what information we collect, how we use it, and the choices you have.
                </p>

                <h2>Information we collect</h2>
                <ul>
                    <li>Account details you provide: name, username, email address, and password.</li>
                    <li>Profile details you choose to add: status, institution, and bio.</li>
                    <li>Content you upload: notes, PDFs, and other study materials.</li>
                    <li>Usage data: pages visited, features used, and learning activity within the platform.</li>
                </ul>

                <h2>How we use your information</h2>
                <ul>
                    <li>To provide, operate, and maintain the platform and your account.</li>
                    <li>To power features such as your public profile, notes library, and AI tools.</li>
                    <li>To communicate with you about your account, security, and important updates.</li>
                    <li>To improve YeniDers and understand how the platform is used.</li>
                </ul>

                <h2>Sharing of information</h2>
                <p>
                    We do not sell your personal information. We share data only with service
                    providers that help us run the platform (such as hosting, storage, and email
                    delivery), and only to the extent necessary for them to perform those services.
                </p>

                <h2>Your public profile</h2>
                <p>
                    Your profile page is visible to others only if you choose to make it public.
                    You can control what appears there, and you can change your name or username
                    at any time from your profile.
                </p>

                <h2>Data retention and deletion</h2>
                <p>
                    We keep your data for as long as your account is active. You may request
                    deletion of your account and associated data at any time by contacting us.
                </p>

                <h2>Contact</h2>
                <p>
                    Questions about this policy? Reach out through our Contact page.
                </p>
            </main>
            <Footer />
        </div>
    );
};

export default Privacy;
